import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import DomainIcon from '@mui/icons-material/Domain';

interface EmptyStateSitesProps {
  message?: string;
  showImportButton?: boolean;
  onImportClick?: () => void;
}

export const EmptyStateSites: React.FC<EmptyStateSitesProps> = ({
  message = 'No sites found',
  showImportButton = false,
  onImportClick,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 2,
        textAlign: 'center',
      }}
    >
      <DomainIcon
        sx={{
          fontSize: 64,
          color: 'text.disabled',
          mb: 2,
        }}
      />
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {message}
      </Typography>
      {showImportButton && (
        <Button
          variant="contained"
          color="primary"
          onClick={onImportClick}
          sx={{ mt: 2 }}
        >
          Import Site
        </Button>
      )}
    </Box>
  );
};
